import { useTranslation } from "@/features/utils/i18n";

const errorCode = (error: unknown) =>
  (error as { code?: string } | null | undefined)?.code;

/**
 * The booking system had already cancelled the appointment: the server removed it from
 * the calendar too, so there is nothing left to edit — and a cache to refresh even
 * though the request failed.
 */
export const isAppointmentGone = (error: unknown) =>
  errorCode(error) === "appointment_gone";

/**
 * A refusal the calendar routes explained (`code`, see `backoffice-events.ts`), in the
 * user's language — `calendar.messages.errors.<code>` — else the generic message.
 */
export function useBookingErrorMessage() {
  const { t } = useTranslation("calendar");
  return (error: unknown, fallback: string): string => {
    const code = errorCode(error);
    if (!code) return fallback;
    return t(`messages.errors.${code}`, {
      reason: (error as { message?: string }).message,
      defaultValue: fallback,
    });
  };
}
